import { useState } from 'react'
import styles from './CaseBadge.module.css'
import CaseEvidence from './CaseEvidence'

/**
 * CaseBadge — displays a case identifier pill.
 * Clicking the badge opens the CaseEvidence modal.
 *
 * Props:
 *   caseId       {string} — the ticket ID to display (e.g. "ACM-18376")
 *   caseUid      {string} — the id used to fetch evidence (defaults to caseId)
 *   primarySkill {string} — skill this evidence is for; auto-selected in the modal
 *   candidateSkillId {number|string} — set when this badge belongs to a reviewable skill
 *                          candidate (Proposed/Candidates/Rejected); forwarded to
 *                          CaseEvidence so it fetches from Postgres instead of Neo4j.
 */
export default function CaseBadge({ caseId, caseUid, primarySkill, candidateSkillId }) {
  const [open, setOpen] = useState(false)

  if (!caseId) return null

  const uid = caseUid ?? caseId

  return (
    <>
      <span
        className={styles.badge}
        onClick={() => setOpen(true)}
        role="button"
        tabIndex={0}
        onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && setOpen(true)}
        aria-label={`View evidence for case ${caseId}`}
      >
        {caseId}
      </span>

      {open && (
        <CaseEvidence
          ticketId={uid}
          primarySkill={primarySkill}
          candidateSkillId={candidateSkillId}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  )
}
